'use strict';

export const ms = {
    name: 'ms',
    closeText: 'Tutup',
    prevText: '&#x3C;Sebelum',
    nextText: 'Selepas&#x3E;',
    currentText: 'hari ini',
    monthNames: ['Januari', 'Februari', 'Mac', 'April', 'Mei', 'Jun', 'Julai', 'Ogos', 'September', 'Oktober', 'November', 'Disember'],
    monthNamesShort: ['Jan', 'Feb', 'Mac', 'Apr', 'Mei', 'Jun', 'Jul', 'Ogo', 'Sep', 'Okt', 'Nov', 'Dis'],
    dayNames: ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat', 'Sabtu'],
    dayNamesShort: ['Aha', 'Isn', 'Sel', 'Rab', 'kha', 'Jum', 'Sab'],
    dayNamesMin: ['Ah', 'Is', 'Se', 'Ra', 'Kh', 'Ju', 'Sa'],
    weekHeader: 'Mg',
    dateFormat: 'dd/mm/yy',
    firstDay: 0,
    isRTL: !1,
    showMonthAfterYear: !1,
    yearSuffix: ''
};
